import { render, staticRenderFns } from "./backManagement.vue?vue&type=template&id=41c91fec&scoped=true&"
import script from "./backManagement.vue?vue&type=script&lang=js&"
export * from "./backManagement.vue?vue&type=script&lang=js&"
import style0 from "./backManagement.vue?vue&type=style&index=0&id=41c91fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c91fec",
  null
  
)

export default component.exports